import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../Firebase/Config";
import RouteWithTitle from "../../Layout/RouteWithTitle";
import Loading from "../../Home-Page/Main/Loading/Loading";

function Showproject() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const onDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "contect", id.toString()));
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    const ref = collection(db, "contect");
    getDocs(ref).then((snapshot) => {
      if (snapshot.empty) {
        setError("خطایی رخ داد");
        setLoading(false);
      } else {
        setLoading(false);
        const unsubscribe = onSnapshot(ref, (snapshot) => {
          let result = [];
          snapshot.docs.forEach((doc) => {
            result.push({ id: doc.id, ...doc.data() });
          });
          setData(result);
        });
        return () => unsubscribe();
      }
    });
  }, []);

  return (
    <>
      <RouteWithTitle>
        <div className="flex flex-col bg-slate-700 h-full p-5 overflow-y-scroll text-white">
          <div className="flex">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="p-2">تعداد</th>
                  <th className="p-2">نام و نام خانوادگی</th>
                  <th className="p-2">ایمیل</th>
                  <th className="p-2">موضوع پیام</th>
                  <th className="p-2">پیام</th>
                  <th className="p-2">پاک کردن</th>
                </tr>
              </thead>
              <tbody>
                {error ? (
                  error
                ) : loading ? (
                  <tr>
                    <td>
                      <Loading />
                    </td>
                  </tr>
                ) : data ? (
                  data
                    .sort((a, b) => a.Id - b.Id)
                    .map((item) => (
                      <tr key={item.Id}>
                        <th className="border p-2">{item.Id}</th>
                        <td className="border p-2">{item.FirstAndLastname}</td>
                        <td className="border p-2">{item.Email}</td>
                        <td className="border p-2">{item.Subject}</td>
                        <td className="border p-2">{item.Message}</td>
                        <td className="border p-2">
                          <Icon
                            icon="mingcute:delete-line"
                            wirth="30"
                            height="30"
                            className="cursor-pointer mr-2 mt-1"
                            onClick={() => onDelete(item.id)}
                          />
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td>
                      <p>داده‌ای وجود ندارد</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </RouteWithTitle>
    </>
  );
}

export default Showproject;
